import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageBoxBase } from '../shared/message-box.base';
import { TtyMessageLogView } from '../shared/tty-message-log.view'
import { TtyMapperService } from '../shared/tty-mapper.service';
import { MessageLogOverviewModel } from '../../../core/models/message-log-overview.model'
import { MessageLogService } from '../../../core/services/message-logs.service';
import { DateConverterService } from 'src/app/core/utils/date-converter.service';
import { GatewayService } from 'src/app/core/services/gateway.service';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'gw-outbox',
    templateUrl: 'outbox.component.html',
    styleUrls: ['../shared/message-box.component.css']
})
export class OutboxComponent extends MessageBoxBase implements OnInit {

    public itemDoubleClick: TtyMessageLogView;
    private unread;
    @Output() unreadOutbox = new EventEmitter();

    constructor(
        dateConverterService: DateConverterService,
        messageLogService: MessageLogService,
        gatewayService: GatewayService,
        toastr: ToastrService,
        private ttyMapperService: TtyMapperService,
    ) {
        super(dateConverterService, messageLogService, gatewayService, toastr)
    }

    ngOnInit() {
        this.searchMessageLog();
        this.closeDetailFlag = true;
        this.searchText = '';
        this.filter = 'Filter';
    }

    reLoadMessageBox() {
        this.searchText = '';
        this.filter = 'Filter';
        setTimeout(() => {
            this.searchMessageLog();
        }, 2000);
    }

    private showMessageLogDetail($event) {
        this.itemDoubleClick = $event;
        this.showMessageLogDetailBase(this.itemDoubleClick);
    }

    private searchMessageLog() {
        this.clearValue();
        this.searchMessageLogBase()
            .subscribe(
                (response: MessageLogOverviewModel[]) => {
                    this.dataAll = this.ttyMapperService.toTtyMessageViews(response, true);
                    this.dataAll = this.dataAll.filter(d => d.archiveDateTime == null);
                    this.data$.next(this.dataAll);
                    this.unreadCount.next(true);
                    this.unread = this.dataAll.filter(d => d.readDateTime == null).length;
                    this.getUnreadOutbox();
                    this.dataAllPaging = this.ttyMapperService.toTtyMessagePagingViews(response);
                },
                error => {
                    console.log(error);
                }
            );
    }

    private getUnreadOutbox() {
        this.unreadOutbox.emit(this.unread);
    }

    private subjectTrig($event) {
        this.functionOnBase($event);
    }
}